// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36L7y","top":"styles_top__19n48"};